
<kendo-label [for]="personPicker" [text]="'substitute.admin.search.label' | i18n">
  <div style="width: 250px; display: inline-block;">
  <sp-people-picker
  #personPicker
    [(value)]="person"
    [maxPeople]="1"
  ></sp-people-picker>
</div>
<div style="width: 250px; display: inline-block;">
  <ece-btn-edit ngClass=""
    (click)="onClick()"
    [text]="'substitute.admin.search.text' | i18n"
    [disabled]="person.length === 0"
  ></ece-btn-edit>
</div>
</kendo-label>

